export default "__VITE_ASSET__33c86df0__"